/*       */

import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PageNotAllowed from 'app/containers/ErrorPages/PageNotAllowed';
import GeneralSettings from 'app/containers/Admin/Settings/GeneralSettings';
import AuthenticationMain from 'app/containers/Admin/Settings/Authentication/AuthenticationMain';
import BruteForceDetectionMain from 'app/containers/Admin/Settings/BruteForceDetection/BruteForceDetectionMain';
import IdentityProvidersRoute from 'app/containers/Admin/Settings/IdentityProviders/IdentityProvidersRoute';
import TokenSettingsMain from 'app/containers/Admin/Settings/TokenSettings/TokenSettingsMain';
import LlmProvidersRoute from 'app/containers/Admin/Settings/Ai/LlmProvidersRoute';
import { loadSecurityGeneral } from 'store/actions/app/appActions';
import SiteMapsSettings from './SiteMapsSettings';
import MapsAdminSection from 'app/containers/Maps/SituationalAwareness/MapsAdminSection';
import { baseRoutes } from 'app/config/routesConfig';

const AdminRoutes = props => {
    const { userProfile, loadSecurityGeneral } = props;

    useEffect(() => {
        loadSecurityGeneral();
    }, [loadSecurityGeneral]);

    const { permissions, isAdmin } = userProfile;
    const permissionsSet = new Set(permissions || []);
    const canView = isAdmin || permissionsSet.has('admin.settings') || permissionsSet.has('admin.sso') || permissionsSet.has('admin.map');
    if (!canView) {
        return <PageNotAllowed title="Admin Settings" />;
    }
    return (
        <Switch>
            <Route path="/admin/settings/general" component={GeneralSettings} />
            <Route path="/admin/settings/authentication" component={AuthenticationMain} />
            <Route path="/admin/settings/brute-force-detection" component={BruteForceDetectionMain} />
            <Route path="/admin/settings/identity-providers" component={IdentityProvidersRoute} />
            <Route path={baseRoutes['site-maps']} component={SiteMapsSettings} />
            <Route path={baseRoutes['admin-maps']} component={MapsAdminSection} />
            <Route path="/admin/settings/tokens" component={TokenSettingsMain} />
            <Route path="/admin/settings/ai" component={LlmProvidersRoute} />
        </Switch>
    );
};

export default connect(
    (state, ownProps) => ({
        userProfile: state.user.profile,
    }),
    {
        loadSecurityGeneral,
    }
)(AdminRoutes);
